import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Notification, ResponseMessage } from '../models/Notification';
import { UtilService } from './util.service';
import { HttpService } from './http.service';
import { AuthService } from './auth.service';
import { MenuService } from './menu.service';
import { PlusConfig } from '../environments/plus-enviroment';
import { ADN_PLUS } from '../models';
declare var io: any;
declare var $: any;

@Injectable()
export class PlusNotificationService {


  private notificationSubject = new BehaviorSubject([]);
  private notificationsSocket;
  private socketEndPoint: string = PlusConfig.UNL.ENDPOINT;
  //private componentService: ComponentService
  constructor(private utilService: UtilService, private http: HttpService,private auth: AuthService, private menuService: MenuService) { }

  public setNotificationsSocket(socket): void { this.notificationsSocket = socket }
  public getNotificationsSocket(): any { return this.notificationsSocket }

  public getStaticsNotifications(): Observable<Notification[]> { return this.notificationSubject.asObservable() }
  public setStaticNotifications(notifications: Notification[]) { this.notificationSubject.next(notifications) }

  public parseAdnToNotification(adn: ADN_PLUS): Notification {
    let not = new Notification();
    let entities = adn.ArrayEntities.List;
    not.id = this.utilService.getStringAttribute("NOTIFICATION_ID", entities);
    not.description = this.utilService.getStringAttribute("DESCRIPTION", entities);
    not.type = this.utilService.getStringAttribute("NOTIFICATION_TYPE", entities);
    not.date = this.parseDateToTimeAgo(this.utilService.getStringAttribute("NOTIFICATION_DATE", entities));
    not.readIndicator = (this.utilService.getStringAttribute("READ_INDICATOR", entities) == 'S') ? true : false;
    not.actionLink = this.utilService.getStringAttribute("ACTION_LINK", entities) || null;
    not.isStatic = (this.utilService.getStringAttribute("IND_STATIC", entities) == 'S') ? true : false;
    not.expiration = this.utilService.getStringAttribute("EXPIRATION_DATE", entities) || null;
    return not;
  }

  private parseDateToTimeAgo(pPlusDate: any) {
    let plusDate: any = new Date(pPlusDate.replace(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/, '$4:$5:$6 $2/$3/$1'));

    let actualTime: any = new Date();
    let msPerMinute = 60 * 1000;
    let msPerHour = msPerMinute * 60;
    let msPerDay = msPerHour * 24;
    let msPerMonth = msPerDay * 30;
    let msPerYear = msPerDay * 365;

    let elapsed = actualTime - plusDate;

    if (elapsed < msPerMinute) {
      return 'hace ' + Math.round(elapsed / 1000) + ' segundos';
    }

    else if (elapsed < msPerHour) {
      return 'hace ' + Math.round(elapsed / msPerMinute) + ' minutos';
    }

    else if (elapsed < msPerDay) {
      return 'hace ' + Math.round(elapsed / msPerHour) + ' horas';
    }

    else if (elapsed < msPerMonth) {
      return 'hace ' + Math.round(elapsed / msPerDay) + ' días';
    }

    else if (elapsed < msPerYear) {
      return 'hace ' + Math.round(elapsed / msPerMonth) + ' meses';
    }

    else {
      return 'hace ' + Math.round(elapsed / msPerYear) + ' años';
    }

  }

  public markAsSeen(id, callback) {
    this.http.post(HttpService.ENDPOINT + '/api/v1/NotificationService/MarkAsSeen/' + id, {}).subscribe((x) => callback(x), (e) => { console.log(e) });
  }

  // downloadReport(n, s, e) {
  //   this.http.post(this.getActionLink(n), {}).subscribe((x) => s(x), () => e(e));
  // }

  public getActionLink(n: Notification): string[] {
    let actionLink = n.actionLink || '';
    // if (!actionLink || actionLink == "null") return []
    // let actionLinkArray = 
    return actionLink.split(':');
    // let r = actionLinkArray[2].split('.');
    // switch (actionLinkArray[1]) {
    //   case 'REPORT_DOWNLOAD':      
    //     return `${HttpService.ENDPOINT}/api/v1/ReportService/DownloadReport/${r[0]}/${r[1]}`;//?source=${'FTP'};
    //   default:
    //     return null;
    // }
  }

  public processActionLink(n: Notification) {
    let actionLinkArray = this.getActionLink(n);//actionLink.split(':');
    if (actionLinkArray.length == 1) return;

    switch (actionLinkArray[1]) {
      case 'REPORT_DOWNLOAD':
        let r = actionLinkArray[2].split('.');
        this.http.post(`${HttpService.ENDPOINT}/api/v1/ReportService/DownloadReport/${r[0]}/${r[1]}`, {}).subscribe((x) => {
          x = JSON.parse(x);
          if (x.FilesData) {
            let report = x.FilesData[0];
            let byteArray = this.utilService.getByteArray(report);
            var blob = new Blob([byteArray], { type: 'pdf' });
            this.utilService.downloadPlusReport(report, blob);
          }
        });
        break;
      case 'VIEW':
        //this.router.navigate(['/home/ssvmn/' + actionLinkArray[2]]);
        this.menuService.navigateTo(actionLinkArray[2], actionLinkArray[2])
        break;
      default:
        return null;
    }
  }

  public createSocketAction() {
    if (localStorage.getItem("loggedUser") === "undefined") { return }

    let loggedUser = {
      userCode: this.utilService.getStringAttribute("USER_CODE", JSON.parse(localStorage.getItem("loggedUser")).ArrayEntities.List),
      numDepartment: this.utilService.getStringAttribute("NUM_DEPTO", JSON.parse(localStorage.getItem("loggedUser")).ArrayEntities.List)
    }

    this.notificationsSocket = io.connect(this.socketEndPoint, { query: "UserCode=" + loggedUser.userCode + "&NumDepartment=" + loggedUser.numDepartment });

    this.auth.userSocket = this.notificationsSocket;
    return this.notificationsSocket;
  }

  public getAllNotifications(userCode: string, readIndicator = ''): any {
    return this.http.get(`${HttpService.ENDPOINT}/api/v1/NotificationService?userCode=${userCode}&readIndicator${readIndicator}`);
  }

  public getInitialNotifications(readIndicator = ''): any {
    let userCode = this.utilService.getStringAttribute("USER_CODE", JSON.parse(localStorage.getItem("loggedUser")).ArrayEntities.List);
    return this.getAllNotifications(userCode, readIndicator);
  }

  public processNotifications(pNotifications, processStatics = false): Notification[] {
    pNotifications = JSON.parse(pNotifications);
    let notificationList = [];
    for (let notificationAdn of pNotifications) {
      let notification: Notification = this.parseAdnToNotification(notificationAdn);
      notificationList.push(notification);
    };
    if (processStatics)
      this.setStaticNotifications(notificationList);
    return notificationList;
  }

  public markNotificationClosed(id, callback): void {
    this.http.post(HttpService.ENDPOINT + '/api/v1/NotificationService/MarkClosed/' + id, {}).subscribe(() => {
      callback();
    }, (e) => { console.log(e) });
  }

  public showTempStaticNotification(message: ResponseMessage): void {
    let not = new Notification();
    not.description = message.Message || message.ExceptionMessage;
    not.type = 'W'//message.MessageType;
    not.isStatic = true;
    this.setStaticNotifications([not]);
  }

  public mergeArrays(a, b): any[] {
    var args = arguments;
    var hash = {};
    var arr = [];
    for (var i = 0; i < args.length; i++) {
      for (var j = 0; j < args[i].length; j++) {
        if (hash[args[i][j]] !== true) {
          arr[arr.length] = args[i][j];
          hash[args[i][j]] = true;
        }
      }
    }
    return arr;
  }
}
